import { RoleDetailResponse } from '../../role-management/models/role-management-api.model';
import { PolicyDetailResponse } from '../models/policy-api.model';
import { PortalUserDetail } from '../models/user-management-api';

export interface UserManagementState {
  selectedUser: PortalUserDetail | null;
  roleDetails: Record<string, RoleDetailResponse>;
  policyDetails: Record<string, PolicyDetailResponse>;
  loadingDetail: boolean;
  loadingPolicy: boolean;
  submitting: boolean;
  updatingStatus: boolean;
  error: string | null;
  successMessage: string | null;
}

export const initialUserManagementState: UserManagementState = {
  selectedUser: null,
  roleDetails: {},
  policyDetails: {},
  loadingDetail: false,
  loadingPolicy: false,
  submitting: false,
  updatingStatus: false,
  error: null,
  successMessage: null,
};
